module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "55%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "55%",
				"height": "45%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#043f61"
					},
					{
						"y": 89.28571428571429,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#09472e"
					},
					{
						"y": 53.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#043f61"
					},
					{
						"y": 82.75862068965517,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.3103448275862,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.13793103448276,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#09472e"
					},
					{
						"y": 46.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.11320754716981,
						"dataLabels": {
							"enabled": false,
							"format": "52"
						},
						"color": "#043f61"
					},
					{
						"y": 86.79245283018868,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.90566037735849,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.01886792452831,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#09472e"
					},
					{
						"y": 50.943396226415096,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "259"
						},
						"color": "#043f61"
					},
					{
						"y": 93.82239382239382,
						"dataLabels": {
							"enabled": false,
							"format": "243"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.5057915057915,
						"dataLabels": {
							"enabled": false,
							"format": "237"
						},
						"color": "#0d4440"
					},
					{
						"y": 87.25868725868726,
						"dataLabels": {
							"enabled": false,
							"format": "226"
						},
						"color": "#09472e"
					},
					{
						"y": 66.02316602316603,
						"dataLabels": {
							"enabled": false,
							"format": "171"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#043f61"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0d4440"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#09472e"
					},
					{
						"y": 21.428571428571427,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "66"
						},
						"color": "#043f61"
					},
					{
						"y": 96.96969696969697,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.42424242424242,
						"dataLabels": {
							"enabled": false,
							"format": "61"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.81818181818183,
						"dataLabels": {
							"enabled": false,
							"format": "54"
						},
						"color": "#09472e"
					},
					{
						"y": 59.09090909090909,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "237"
						},
						"color": "#043f61"
					},
					{
						"y": 88.18565400843882,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.54430379746836,
						"dataLabels": {
							"enabled": false,
							"format": "198"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.68354430379746,
						"dataLabels": {
							"enabled": false,
							"format": "177"
						},
						"color": "#09472e"
					},
					{
						"y": 49.36708860759494,
						"dataLabels": {
							"enabled": false,
							"format": "117"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0c4250"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0d4440"
					},
					{
						"y": 38.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#09472e"
					},
					{
						"y": 22.22222222222222,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#043f61"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0c4250"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#0d4440"
					},
					{
						"y": 60,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#09472e"
					},
					{
						"y": 36.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#043f61"
					},
					{
						"y": 89.85507246376811,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.05797101449275,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.81159420289855,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#09472e"
					},
					{
						"y": 44.927536231884055,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.16176470588235,
						"dataLabels": {
							"enabled": false,
							"format": "267"
						},
						"color": "#043f61"
					},
					{
						"y": 83.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "228"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.61764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "222"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.10294117647058,
						"dataLabels": {
							"enabled": false,
							"format": "207"
						},
						"color": "#09472e"
					},
					{
						"y": 56.98529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "155"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.71428571428571,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.043478260869568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.24137931034483,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.1666666666666625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.521739130434778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.2093023255814,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.8867924528301883,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.538461538461542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.1739130434782594,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.2222222222222254,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.63636363636363,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.177606177606176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4691358024691357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.641350210970463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.336283185840713,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.1666666666666625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.434782608695656,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -62.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0303030303030276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.6875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.475409836065575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.77777777777778,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.814345991561181,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.606060606060607,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.89830508474576,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.888888888888886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.144927536231885,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.62068965517241,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.509433962264154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.8382352941176516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.60674157303371,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.631578947368418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.756756756756754,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.120772946859905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=28"
			},
			{
				"x": 9,
				"text": "30-39<br>n=58"
			},
			{
				"x": 15,
				"text": "40-49<br>n=53"
			},
			{
				"x": 21,
				"text": ">=50<br>n=259"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=12"
			},
			{
				"x": 34,
				"text": "30-39<br>n=28"
			},
			{
				"x": 40,
				"text": "40-49<br>n=66"
			},
			{
				"x": 46,
				"text": ">=50<br>n=237"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=18"
			},
			{
				"x": 59,
				"text": "30-39<br>n=30"
			},
			{
				"x": 65,
				"text": "40-49<br>n=69"
			},
			{
				"x": 71,
				"text": ">=50<br>n=272"
			}
		],
		"dataTable": {
			"MSM:<30": [
				28,
				28,
				25,
				23,
				20,
				15
			],
			"MSM:30-39": [
				58,
				58,
				48,
				46,
				43,
				27
			],
			"MSM:40-49": [
				53,
				52,
				46,
				45,
				44,
				27
			],
			"MSM:>=50": [
				259,
				259,
				243,
				237,
				226,
				171
			],
			"Non-MSM:<30": [
				12,
				12,
				12,
				12,
				9,
				8
			],
			"Non-MSM:30-39": [
				28,
				28,
				24,
				23,
				16,
				6
			],
			"Non-MSM:40-49": [
				66,
				66,
				64,
				61,
				54,
				39
			],
			"Non-MSM:>=50": [
				237,
				237,
				209,
				198,
				177,
				117
			],
			"Unknown:<30": [
				18,
				12,
				9,
				9,
				7,
				4
			],
			"Unknown:30-39": [
				30,
				30,
				20,
				20,
				18,
				11
			],
			"Unknown:40-49": [
				69,
				69,
				62,
				58,
				53,
				31
			],
			"Unknown:>=50": [
				272,
				267,
				228,
				222,
				207,
				155
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_5.json
// module id = 340
// module chunks = 0